import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import React, {useState} from "react";

const ImageUploadDialog = ({ 
    open, 
    setOpen,
    confirmCallback,
}) => {
    
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    
    const onConfirm = () => {
        confirmCallback(file);
        onCancel();
    }
    
    const onCancel = () => {
        setFile(null);
        setPreview(null);
        setOpen(false);
    }

    const handleFileChange = (e) => {
        const currentFile = e.target.files[0];
        setFile(currentFile);
        if (!currentFile) return;

        setPreview(URL.createObjectURL(currentFile));
    };
    
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Upload main image for blog!</DialogTitle>

            <DialogContent>
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange} // onFileUploadChange(e, item)}
                />
                
                { preview && (
                    <img
                        src={preview}
                        alt="Preview"
                        style={{ width: "100%", marginTop: "10px" }}
                    />
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onConfirm} variant="contained">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ImageUploadDialog